var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal cancel-modal"},[_c('div',{class:_vm.modalClass},[_c('div',{staticClass:"cancel-modal-container"},[(1 === _vm.step)?_c('cancel-start',{on:{"next-step":function($event){_vm.step++}}}):_c('question')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }